export default "__VITE_ASSET__DWUKUko2__"